import React from "react";
import "./i18n/i18n.js";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { ThemeProvider } from "@mui/material";
import { theme } from "./utils/theme";
import { DetailsProvider } from "./components/Menu/DetailsToMenu";

// Suppress ResizeObserver loop error (benign warning from chart/responsive components)
// This error is non-critical and commonly occurs with charting libraries
const resizeObserverErr = (e) => {
  if (e.message?.includes?.("ResizeObserver loop") ||
      e.message?.includes?.("ResizeObserver loop completed with undelivered notifications")) {
    const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay-div");
    const resizeObserverErrOverlay = document.getElementById("webpack-dev-server-client-overlay");
    if (resizeObserverErrDiv) resizeObserverErrDiv.style.display = "none";
    if (resizeObserverErrOverlay) resizeObserverErrOverlay.style.display = "none";
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
    return true;
  }
};
window.addEventListener("error", resizeObserverErr);
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason?.message?.includes?.("ResizeObserver loop")) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <DetailsProvider>
        <App />
      </DetailsProvider>
    </ThemeProvider>
  </React.StrictMode>
);
